import { pl } from 'date-fns/locale';
import { format } from 'date-fns';

export const formatDate = (date, fmt = 'd MMM') => {
    return format(new Date(date), fmt, { locale: pl });
};

export const outputDateFormat = (date) => format(date, 'EEE dd.MM', { locale: pl });
